import { HatchProcessor } from './hatch';
import { PdmProcessor } from './pdm';

export const processors = [new HatchProcessor(), new PdmProcessor()];
